export default {
    CREATE_TEMPLATE: () => '/template/createTemplate',
    GET_ALL_TEMPLATE: (data) => `/template/getAllTemplate?${data ? data : ""}`,
    DELETE_TEMPLATE: (id) => `/template/deleteTemplate/${id}`,
    UPDATE_TEMPLATE: (id) => `/template/updateTemplate/${id}`,
    GET_TEMPLATE_ID: (id) => `/template/getTemplateBy/${id}`,
    GET_TEMPLATE_FOLDER: () => '/templateFolder',
    GET_ALL_FOLDER: () => '/templateFolder/getAll',
};
